

































































import { Component, Vue, Watch, Emit } from "vue-property-decorator";

import config from "../../config";
import adminUserService from "../../services/AdminUserService";
import moment from 'moment';
var _ = require("underscore")._;

@Component
export default class AdminUserForm extends Vue {
  private title: string = "Admin User";
  private musicLabels: any = [];
  private roleOptions: any = [
    {
      text: "USER",
      value: "USER"
    },
    {
      text: "ADMIN",
      value: "ADMIN"
    }
  ];
  private statusOptions: any = [
    {
      text: "Active",
      value: "A"
    },
    {
      text: "Inactive",
      value: "I"
    }
  ];
  private adminUser: any = {
    email: "",
    adminUserRole: null,
    lastLoginDate: null,
    createdDate: null,
    createdBy: 0,
    updatedDate: null,
    updatedBy: 0,
    status: "A"
  };

  created() {
    const id: number = +this.$route.params.id;
    this.getAdminUser(id);
  }

  getAdminUser(id: number) {
    adminUserService.getAdminUser(id).then((response: any) => {
      console.log(response.data);
      this.adminUser = response.data;
    });
  }

  displayMusicLabel(musicLabel: any) {
    console.log(musicLabel);
    if (musicLabel && musicLabel.name) {
      return `${musicLabel.name} / ${musicLabel.nameEN}`;
    }
    return "";
  }
  
  formatdate(dateTiem: any) {
    if (dateTiem) {
      return moment(String(dateTiem)).format('DD/MM/YYYY hh:mm:ss');
    }
  }

  updateAdminUser(adminUser: any) {
    this.$swal({
      title: "Waiting",
      timer: 10000,
      allowOutsideClick: false,
      onBeforeOpen: () => {
        this.$swal.showLoading();
      }
    });

    adminUserService
      .updateAdminUser(adminUser)
      .then((response: any) => {
        this.$swal({
          confirmButtonColor: "#28a745",
          title: "Complete",
          type: "success",
          onClose: () => {
            this.$router.push({ name: "adminUser" });
          }
        });
      })
      .catch((error: any) => {
        this.$swal({
          title: "Please try again!",
          type: "error"
        });
      });
  }
}
